import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Gift } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ClosingCTA() {
  return <section className="py-24 bg-emerald-900 text-white text-center" data-id="element-60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="max-w-4xl mx-auto" data-id="element-62">
          <div className="space-y-4 mb-12 text-emerald-100 text-lg md:text-xl font-medium leading-relaxed" data-id="element-63">
            <p data-id="element-64">Imaginá terminar el día…</p>
            <p data-id="element-65">Sin hinchazón.</p>
            <p data-id="element-66">Sin culpa.</p>
            <p data-id="element-67">Sin preguntarte qué hice mal.</p>
            <p className="text-white font-bold text-2xl md:text-3xl pt-4" data-id="element-68">
              Solo sintiéndote liviana. Tranquila. En paz con tu cuerpo.
            </p>
          </div>

          <p className="text-lg text-emerald-200 mb-10 max-w-2xl mx-auto" data-id="element-69">
            Eso no es un sueño lejano. Es lo que pasa cuando le das a tu
            digestión lo que necesita. Y podés empezar hoy.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-70">
            <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" onClick={e => trackAddToCart(e)} data-id="element-71">
              <Button variant="secondary" size="xl" withArrow className="w-full md:w-auto px-12 py-6 text-xl shadow-2xl shadow-emerald-900/50 hover:scale-105 transform transition-all" data-id="element-72">
                SÍ, QUIERO EL MÉTODO 28 DÍAS SIN INFLAMACIÓN
              </Button>
            </a>

            <div className="text-center" data-id="element-73">
              <p className="text-xl md:text-2xl font-bold text-white" data-id="element-74">
                $14,997 con el 50% desc
              </p>
              <p className="text-sm font-medium text-emerald-300" data-id="element-75">
                Pago único — sin suscripciones
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-emerald-300 mt-4" data-id="element-76">
              <div className="flex items-center bg-emerald-800/50 px-3 py-1 rounded-full" data-id="element-77">
                <Zap className="w-4 h-4 mr-1.5" data-id="element-78" />
                Acceso inmediato
              </div>
              <div className="flex items-center bg-emerald-800/50 px-3 py-1 rounded-full" data-id="element-79">
                <Gift className="w-4 h-4 mr-1.5" data-id="element-80" />
                Bonos incluidos
              </div>
              <div className="flex items-center bg-emerald-800/50 px-3 py-1 rounded-full" data-id="element-81">
                <ShieldCheck className="w-4 h-4 mr-1.5" data-id="element-82" />
                Garantía 7 días
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}